// new group photo selection
export const addPhotoToStorage = (file, userId, storage, callback) => {
  let storageRef = storage.ref();
  let profilePhotoRef = `images/groups/${userId}`
  let uploadTask = storageRef.child(profilePhotoRef).put(file);

  // Register three observers:
  // 1. 'state_changed' observer, called any time the state changes
  // 2. Error observer,` called on failure
  // 3. Completion observer, called on successful completion
  uploadTask.on('state_changed', 
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      // if(progress > 0 && progress < 100){
      //   setShowProgress({visible: true, width: progress})
      // }else{
      //   setShowProgress({visible: false, width: progress})
      // }
    }, 
    (error) => {
      // Handle unsuccessful uploads
    }, 
    () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        callback(downloadURL);
      });
    }
  );
}

export const uploadPhoto = (e, userId, storage, callback) => {
  const file = e.target.files[0];
  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg', 'image/webp'];
  if(validTypes.includes(file.type)){
    addPhotoToStorage(file, userId, storage, callback)
  }else{
    alert('invalid file: only svg, png, jpeg, webp and jpg files are supported')
  }
}